import Header from '@/components/Header';
import Resources from '@/components/Resources';
import Footer from '@/components/Footer';
import SEO from '@/components/SEO';

const ResourcesPage = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <SEO
        title="Resources & Learning | Freeman & Crown Law"
        description="Access our comprehensive resources and learning center with legal education, DIY processes, and guidance to master constitutional law and legal processes."
        image="/lovable-uploads/15868f15-6c06-4358-98e2-9fc153ff4e2c.png"
        url={window.location.origin + '/resources-learning'}
        type="website"
      />
      <Resources />
      <Footer />
    </div>
  );
};

export default ResourcesPage;